// extracted by mini-css-extract-plugin
export default {"values":"styles_values__zF3OK","value":"styles_value__Mc4CS","icon":"styles_icon__hzdbJ"};